import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { contentLibraryFilePreviewClosed } from 'features/content-library/actions';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';

export const useContentPreviewCloseControl = () => {
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(contentLibraryFilePreviewClosed());
  };

  return {
    handleClick,
    label: t('grid.close_preview_tooltip'),
  };
};

export const ContentPreviewCloseControl = () => {
  const { handleClick, label } = useContentPreviewCloseControl();

  return <GridPanelControl tooltip={label} icon="close" onClick={handleClick} />;
};
